import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAskedImagesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#FEF3E9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 18C18.1046 18 19 17.1046 19 16C19 14.8954 18.1046 14 17 14C15.8954 14 15 14.8954 15 16C15 17.1046 15.8954 18 17 18Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 10H17C12 10 10 12 10 17V23C10 28 12 30 17 30H23C28 30 30 28 30 23V18",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.75 13H29.25",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 15.75V10.25",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6699 26.9486L15.5999 23.6386C16.3899 23.1086 17.5299 23.1686 18.2399 23.7786L18.5699 24.0686C19.3499 24.7386 20.6099 24.7386 21.3899 24.0686L25.5499 20.4986C26.3299 19.8286 27.5899 19.8286 28.3699 20.4986L29.9999 21.8986",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAskedImagesIcon;
